import { lastValueFrom } from 'rxjs';
import { AuthService } from './services/auth.service';
import { TranslocoService } from '@jsverse/transloco';

export function initAuth(authService: AuthService): () => Promise<void> {
  return () => authService.extractTokenFromUrl();
}

export function preloadLanguage(translocoService: TranslocoService) {
  return () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const language = urlSearchParams.get('language') || 'engb';

    translocoService.setActiveLang(language);
    return lastValueFrom(translocoService.load(language));
  };
}
